import { render, staticRenderFns } from "./DeclaracionAplicabilidad.vue?vue&type=template&id=ac3b3456&"
import script from "./DeclaracionAplicabilidad.vue?vue&type=script&lang=js&"
export * from "./DeclaracionAplicabilidad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports